import { hooks } from '@approvalmax/utils';
import { selectors } from 'modules/common';
import { domain } from 'modules/data';
import { useSelector } from 'modules/react-redux';
import { useUserBetaFeatures } from 'shared/hooks';

import { getRequest } from '../selectors/pageSelectors';

export const usePageRedesign = (props: { exclude?: domain.IntegrationCode[] } = {}) => {
    const { exclude } = props;

    const { isBelgradeUIXeroBillForm, isBelgradeUIStandaloneForm } = useUserBetaFeatures();

    const [workflowId] = hooks.useQueryParam('workflowId');

    const template = useSelector((state) => selectors.template.findTemplateById(state, workflowId || ''));
    const request = useSelector(getRequest);

    const isXeroContactForm =
        template?.integrationCode === domain.IntegrationCode.XeroContact ||
        request?.integrationCode === domain.IntegrationCode.XeroContact;

    // TODO: When we will redesign other forms, we will need to add them beta feature here
    return {
        isPageRedesign:
            isBelgradeUIXeroBillForm ||
            isBelgradeUIStandaloneForm ||
            (isXeroContactForm && !exclude?.includes(domain.IntegrationCode.XeroContact)),
    };
};
